import crop_list from "./crop_list";

const plots = {
        // Titles
        title: String("Parcel·les"),
        plotsTableTitle: String("Gestió de les meves parcel·les"),
        
        // Table headers
        plotName: String("Nom de la parcel·la"),
        plotCropId: String("Tipus de cultiu"),
        plotTerrainBelongs: String("Finca associada"),
        plotActionHeader: String("Accions"),

        // Buttons
        plotNewPlotButton: String("Crear nova parcel·la"),
        plotPlotActionModify: String("Modificar"),
        
        // Modal
        deletePromptModalTitle: String("Eliminar parcel·la"),
        deleteModalBody: String("Estas apunt d'eliminar una parcel·la. Un cop eliminada serà impossible restablir-la. Estas segur que la vols eliminar?"),
        deleteModalAccept: String("Eliminar"),
        deleteModalRejec: String("Cancel·lar"),
};

plots.crop_list = crop_list;

export default plots;